<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-tab-group>
  <mat-tab label="Roles">
    <ng-template matTabContent>
      <app-admin-system-roles></app-admin-system-roles>
    </ng-template>
  </mat-tab>
  <mat-tab label="Collection Roles">
    <ng-template matTabContent>
      <app-admin-collection-roles></app-admin-collection-roles>
    </ng-template>
  </mat-tab>
  <mat-tab label="Exhibit Roles">
    <ng-template matTabContent>
      <app-admin-exhibit-roles></app-admin-exhibit-roles>
    </ng-template>
  </mat-tab>
</mat-tab-group>
